import { Link } from 'react-router';
import { ChevronRight, Shield } from 'lucide-react';
import { Badge, EmptyState, LinkButton, PageHeader, Spinner } from '../../components/ui';
import { ErrorPanel } from '../../components/ErrorPanel';
import { t } from '../../lib/i18n';
import { useCan } from '../../lib/session';
import { useRoles } from './UsersPage';

export function RolesPage() {
  const canManage = useCan('roles.manage');
  const q = useRoles();
  return (
    <>
      <PageHeader
        title={t('nav.roles')}
        description={t('nav.roles.desc')}
        actions={
          canManage ? (
            <LinkButton to="/admin/roles/new" variant="primary">
              {t('roles.create')}
            </LinkButton>
          ) : null
        }
      />
      {q.isPending ? (
        <Spinner />
      ) : q.isError ? (
        <ErrorPanel error={q.error} onRetry={() => void q.refetch()} />
      ) : q.data.length === 0 ? (
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
          <EmptyState
            action={
              canManage ? (
                <LinkButton to="/admin/roles/new" variant="primary">
                  {t('roles.create')}
                </LinkButton>
              ) : null
            }
          />
        </div>
      ) : (
        <ul className="space-y-3" aria-label={t('nav.roles')}>
          {q.data.map((r) => (
            <li key={r.id}>
              <Link
                to={`/admin/roles/${r.id}`}
                className="group flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50"
              >
                <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand">
                  <Shield aria-hidden="true" className="h-5 w-5" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold text-slate-900">{r.key ? t(`role.${r.key}`) : r.name}</span>
                    {r.builtin ? <Badge>{t('roles.builtin')}</Badge> : null}
                  </span>
                  {r.description ? <span className="block truncate text-sm text-slate-600">{r.description}</span> : null}
                  <span className="mt-0.5 block text-xs text-slate-600">
                    {t(`role.siteScope.${r.siteScope}`)} · {t('roles.users')}: {r.userCount}
                  </span>
                </span>
                <ChevronRight aria-hidden="true" className="h-4 w-4 shrink-0 text-slate-500" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
